"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDataMockup = exports.getMockupKey = void 0;
const getMockupKey = appName => `${appName} API mock`;
exports.getMockupKey = getMockupKey;
const isDataMockup = appName => Boolean(window.localStorage) && Boolean(JSON.parse(localStorage.getItem(getMockupKey(appName)) ?? '0'));
exports.isDataMockup = isDataMockup;
